import type { AnyGUID } from "@pdfking/tfunc"
import { MapAsync } from "@pdfking/tfunc"
import { toRaw } from "vue"

import { MergePdf } from "./pdfengine/Functions"

type Stream = Parameters<typeof MergePdf>[0]

export default async (
  stream: Stream,
  task_id: AnyGUID | undefined = undefined
) => MergePdf(MapAsync(toRaw, stream), task_id)
